import { Source, Layer, type SymbolLayerSpecification } from 'react-map-gl/maplibre'
import { PMTileSources, VisibleLayers } from '~/constants'
import { useAppStore, usePMTiles } from '~/hooks'

export default function WavePointTextLayer() {
  const { sources, layerInfo } = usePMTiles()
  const { layerVisibility, dataset, depths } = useAppStore()
  const source = PMTileSources.WAVES
  const url = sources[PMTileSources.WAVES]

  const config: SymbolLayerSpecification = {
    source,
    id: `${source}-text`,
    type: 'symbol',
    layout: {
      visibility: dataset === 'waves' && layerVisibility[VisibleLayers.WAVES] ? 'visible' : 'none',
      'text-field': ['get', 'point_name'],
      'text-font': ['Roboto Regular'],
      'text-anchor': 'top',
      'text-offset': [0, 1.5],
      'text-size': 12,
      'text-max-width': 10,
    },
    paint: {
      'text-color': 'white',
    },
    ...(dataset === 'waves' && {
      filter:
        depths.length > 0
          ? ['in', ['get', 'point_depth'], ['literal', depths]]
          : ['==', ['get', 'point_depth'], -1], // No match when empty - hides all points
    }),
  }

  return (
    <Source key={source} id={source} type="vector" url={`pmtiles://${url}`}>
      {layerInfo![source].map((l) => (
        <Layer
          key={l.layer}
          source-layer={l.layer}
          minzoom={12}
          {...config}
          id={`${l.layer}-text`}
        />
      ))}
    </Source>
  )
}
